import React from "react";
import { Link } from "react-router-dom";
import "./TopContactBar.css";

const TopContactBar = () => {
  return (
    <div className="top-contact-bar">
      <div className="top-contact-content">
        <div className="top-contact-left">
          <span className="contact-bar-text">
            <i className="las la-phone"></i>
            <a href="tel:02030266258">020 3026 6258</a>
          </span>
          <span className="contact-bar-divider">|</span>
          <span className="contact-bar-text">
            <i className="las la-envelope"></i>
            <a href="mailto:info@alisarprospects.training">
              info@alisarprospects.training
            </a>
          </span>
        </div>
        <div className="top-contact-right">
          <Link to="/contact" className="contact-bar-cta">
            Get Help Now
            <i className="las la-arrow-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TopContactBar;